import { getCookie, getSessionStorage } from "../../../utils";
import BeEndpoints from "../../endpoints";
import { getHeaders } from "../../utils";

const loginApi = (makeRequest, signUpUserData) => {
  const request = {
    path: `${BeEndpoints.LOGIN}`,
    method: "POST",
    data: signUpUserData,
  };

  return makeRequest(request);
};

const logoutApi = (makeRequest, logoutData) => {
  const request = {
    path: `${BeEndpoints.LOGOUT}`,
    method: "POST",
    data: logoutData,
    headers: getHeaders(),
  };
  return makeRequest(request);
};

const profileApi = (makeRequest, hostId) => {
  const request = {
    path: `${BeEndpoints.PROFILE}?host=${hostId}`,
    method: "GET",
    headers: getHeaders(),
  };
  return makeRequest(request);
};

const profileUpdateApi = (makeRequest, hostId, data) => {
  const request = {
    path: `${BeEndpoints.PROFILE}?host=${hostId}`,
    method: "PUT",
    headers: getHeaders(),
    data: data,
  };
  return makeRequest(request);
};

const liveVenueApi = (makeRequest) => {
  const request = {
    path: `${BeEndpoints.VENUE}/${getSessionStorage("host")}`,
    method: "GET",
    headers: getHeaders(),
  };
  return makeRequest(request);
};

const passwordResetApi = (makeRequest, data) => {
  const request = {
    path: `${BeEndpoints.CHANGE_PASSWORD}`,
    method: "PUT",
    headers: getHeaders(),
    data: data,
  };
  return makeRequest(request);
};

const hostRatingAPi = (makeRequest, host, limit, offset) => {
  const request = {
    path:
      BeEndpoints.HOST_UPDATE +
      "?host=" +
      host +
      "&limit=" +
      limit +
      "&offset=" +
      offset,
    method: "GET",
    headers: getHeaders(),
  };
  return makeRequest(request);
};

export {
  loginApi,
  logoutApi,
  profileApi,
  profileUpdateApi,
  liveVenueApi,
  passwordResetApi,
  hostRatingAPi,
};
